import {
    GET_UV_BY_LATLON_FULFILLED,
    GET_UV_BY_LATLON_PENDING,
    GET_UV_BY_LATLON_REJECTED
} from '../actions/uvActions';

import { LOCATION_CHANGED } from '../actions/locationActions';

const initialState = {
    uvIsRefreshing: false
};

export function uv(state = initialState, action)
{
    switch (action.type)
    {
        case LOCATION_CHANGED:
        {
            return initialState;
        }
        case GET_UV_BY_LATLON_PENDING:
        {
            return {
                ...state,
                lastError: {},
                uvIsRefreshing: true
            };
        }

        case GET_UV_BY_LATLON_FULFILLED:
        {
            return {
                ...state,
                uv: action.payload,
                lastError: {},
                uvIsRefreshing: false
            };
        }

        case GET_UV_BY_LATLON_REJECTED:
        {
            return {
                ...state,
                uv: {},
                lastError: action.payload,
                uvIsRefreshing: false
            };
        }
        default:
            return state;
    }
}
